import { render, staticRenderFns } from "./SellerApplicationDetailsModal.vue?vue&type=template&id=12bd1bfc"
import script from "./SellerApplicationDetailsModal.vue?vue&type=script&lang=js"
export * from "./SellerApplicationDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports